<script>
export default {
	lang: 'books',
	props: {
		uncatchedValidation: Object,
		config: Object,
		customizationRef: Object,
	},
	data() {
		return {
			customization: this.customizationRef,
		}
	},
	created() {
		this.$assignDeep(
			this.customization,
			{
				data: {
					name: null,
					name2: null,
					lang: null,
				},
			},
			true
		)
	},
}
</script>

<template>
	<v-row class="flex-grow-1">
		<v-col cols="12" md="4">
			<TextField
				v-model="customization.data.name"
				:label="$lang('Nombre – para quién es')"
				class="customization-tf"
				dense
				plain
				solo
				height="50"
				:counter="config.nameMaxLen"
				:maxlength="config.nameMaxLen"
			/>
		</v-col>
		<v-col cols="12" md="4">
			<TextField
				v-model="customization.data.name2"
				:label="$lang('Nombre – de parte de quién')"
				class="customization-tf"
				dense
				plain
				solo
				height="50"
				:counter="config.name2MaxLen"
				:maxlength="config.name2MaxLen"
			/>
		</v-col>
		<v-col cols="12" md="4">
			<Select
				:label="$lang('Idioma')"
				:items="config.langs"
				v-model="customization.data.lang"
				class="customization-tf"
				dense
				plain
				solo
				height="50"
			/>
		</v-col>
	</v-row>
</template>
